import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import { MercadoInternoDefeitosService } from './mercado-interno-defeitos.service';
import { MercadoInternoMercadoriasService } from './mercado-interno-mercadorias.service';
import { UnidadesMedidasService } from '../unidades-medidas/unidades-medidas.service';
import { Funcoes } from "../funcoes";
import { Global } from "../global";

@Component({
  selector: 'app-mercado-interno-defeitos-form',
  templateUrl: './mercado-interno-defeitos-form.component.html'
})
export class MercadoInternoDefeitosFormComponent implements OnInit {

  enviandoForm = false;
  form: FormGroup;
  title: string;
  defeito: any = {};
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  listMercadorias = [];
  listDefeitos = [];
  listIndicesAcumulados = [];
  listUnidadesMedidas = [];
  carregandoTabelaDefeitos = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private mercadoriasDefeitosService: MercadoInternoDefeitosService,
    private mercadoriasService: MercadoInternoMercadoriasService,
    private unidadesMedidasService: UnidadesMedidasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      id_mercadoria: ['', [
        Validators.required,
        BasicValidators.diferenteZero
      ]],
      id_unidade_medida: ['', [
        Validators.required,
        BasicValidators.diferenteZero
      ]],
      nome_pt: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(90)
      ]],
      descricao_pt: [],
      is_indice_acumulado: [],
      ordem: [],
    });
  }

  ngOnInit() {
    const urlPath = this.router.url.split('?')[0];
    const lastSegment = urlPath.split(/\//).pop();

    if (lastSegment == 'upd') {
      this.pageIsUpd = true;
    }

    if (lastSegment == 'add') {
      this.pageIsAdd = true;
    }

    this.mercadoriasService.get()
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });

    this.unidadesMedidasService.get()
      .subscribe(
        json => {
          this.listUnidadesMedidas = [];
          for (let i in json.Payload) {
            this.listUnidadesMedidas.push({
              id_unidade: json.Payload[i].id_unidade,
              nome: json.Payload[i].nome + ' (' + json.Payload[i].sigla + ')'
            });
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.route.params.subscribe(params => {
      let id = params['id_defeito'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.editarDefeito');
      } else {
        this.title = id ? this.func.traduzir('front.visualizarDefeito') : this.func.traduzir('front.cadastrarNovoDefeito');
      }

      if (!id) {
        if (this.route.snapshot.queryParams["mercadoria"]) {
          this.defeito.id_mercadoria = this.route.snapshot.queryParams["mercadoria"];
          this.changeMercadoria(this.defeito.id_mercadoria);
        }
        return;
      }

      this.mercadoriasDefeitosService.getById(id, ['indices_acumulados'])
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarDefeito') + ': ' + json.Payload[0].nome_pt;
            } else {
              this.title = this.func.traduzir('front.visualizarDefeito') + ': ' + json.Payload[0].nome_pt;
            }
            this.defeito = json.Payload[0];

            this.changeMercadoria(this.defeito.id_mercadoria);

            for (let z in this.defeito['indices_acumulados']) {
              this.listIndicesAcumulados.push(this.defeito['indices_acumulados'][z].id_defeito_indice);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  changeMercadoria(id_mercadoria) {
    if (id_mercadoria) {
      this.carregandoTabelaDefeitos = true;
      this.mercadoriasDefeitosService.get(null, { "id_mercadoria": id_mercadoria })
        .subscribe(data => {
          this.listDefeitos = data['Payload'];
          this.carregandoTabelaDefeitos = false;
        },
          error => {
            this.func.showErro(error.json());
            this.carregandoTabelaDefeitos = false;
          });
    }
  }

  changeSelectDefeitos(id_defeito, e) {
    if (e.target.checked) {
      this.listIndicesAcumulados.push(id_defeito);
    } else {
      let index = this.listIndicesAcumulados.indexOf(id_defeito);
      this.listIndicesAcumulados.splice(index, 1);
    }
  }

  voltar() {
    const idMercadoria = this.route.snapshot.queryParams["mercadoria"] || this.defeito.id_mercadoria;
    if (idMercadoria) {
      this.router.navigate(['/painel', 'mercado-interno-mercadorias', idMercadoria, 'upd'], { queryParams: { abadefeitos: '1' } });
    } else {
      this._location.back();
    }
  }

  save() {
    this.enviandoForm = true;
    let result,
      values = this.form.value;

    if (values.nome_pt && typeof values.nome_pt === 'string') {
      values.nome_pt = values.nome_pt.toUpperCase();
    }
    if (values.descricao_pt && typeof values.descricao_pt === 'string') {
      values.descricao_pt = values.descricao_pt.toUpperCase();
    }

    values['indices_acumulados'] = this.listIndicesAcumulados;

    if (values.id) {
      result = this.mercadoriasDefeitosService.editar(values, values.id);
    } else {
      result = this.mercadoriasDefeitosService.adicionar(values);
    }

    const idMercadoria = this.route.snapshot.queryParams["mercadoria"] || values.id_mercadoria || this.defeito.id_mercadoria;

    result.subscribe(data => {
      if (idMercadoria) {
        this.router.navigate(['/painel', 'mercado-interno-mercadorias', idMercadoria, 'upd'], { queryParams: { abadefeitos: '1' } });
      } else {
        this.router.navigate(['/painel', 'mercado-interno-mercadorias', 'defeitos']);
      }
    },
      error => {
        this.enviandoForm = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/mercado-interno-mercadorias/mercado-interno-defeitos-form.component.ts